import React from "react";
import { View, Image, SafeAreaView, ScrollView, StyleSheet } from "react-native"
import styles from "../../styles";
import Header from "../../components/Header";
import { global } from "../../const";
import { connectionErrorIc } from "../../assets";
import checkConnection from "../../functions/netInfo";
import Button from "../../components/form/Button";
import { PrimaryTitle } from "../../components/labels";
import localize from "../../localize";

export default function ConnectionError(props) {

    const goBacktoHome = async () => {
        let platform = await checkConnection();
        if (platform) {
            if (global.isNative) {
                return props.navigation.navigate("dashboard")
            }
            return props.history.push("/dashboard")
        }
    }

    return (
        <SafeAreaView style={styles.container}>
            {
                !global.isNative && (<Header title={localize.Connection_Error} />)
            }
            <ScrollView>
                <View style={{ flex: 1, paddingHorizontal: 30 }}>
                    <Image
                        style={pageStyles.img}
                        source={connectionErrorIc} />
                    <PrimaryTitle align="center" size={20}>
                        {localize.Oh_no}
                    </PrimaryTitle>
                    <PrimaryTitle align="center" size={14}>
                        {localize.No_Internet_found}
                    </PrimaryTitle>
                    <View style={pageStyles.buttonContainer}>
                        <Button
                            title={localize.Retry}
                            size="small"
                            onPress={goBacktoHome}
                        />
                    </View>
                </View>
            </ScrollView>
        </SafeAreaView>

    )
}


const pageStyles = StyleSheet.create({
    img: {
        width: "60%",
        height: 180,
        alignSelf: 'center',
        marginVertical: 50,
        resizeMode: "contain"
    },
    buttonContainer: {
        paddingTop: 20,
    }

})